
import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ApiPoll, ApiRecommendation, PollsApi } from '@tytapp/api';
import { Link } from '@tytapp/common';
import { UserService } from '@tytapp/user';
import { FollowButton, HomeCard, HomeCardComponentType } from '../home-cards.service';

@Component({
    selector: 'tyt-recommended-polls-home-card',
    templateUrl: './recommended-polls-card.component.html',
    styleUrls: ['./recommended-polls-card.component.scss']
})
export class RecommendedPollsCardComponent implements HomeCardComponentType{
    card: HomeCard;
    title = 'Recommendations';
    icon = { type: 'material', text: 'campaign' } as const;
    more?: Link;
    followButton?: FollowButton;
    hidden?: boolean;
    classes?: string[];
    fullBleed?: boolean;

    state: 'loading' | 'ready' = 'loading';

    poll: ApiPoll;
    petition: ApiPoll;

    private readonly pollsApi = inject(PollsApi);
    private readonly usersService = inject(UserService);

    recommendations: ApiRecommendation[];

    async ngOnInit() {
        await this.usersService.ready;
        this.hidden = !this.usersService.user;
        if (this.usersService.user) {
            let items = await this.pollsApi.getRecommendedPolls().toPromise();
            this.petition = items.find(x => x.type === 'Petition');
            this.poll = items.find(x => x.type !== 'Petition');
            this.recommendations = [];

            if (this.petition) {
                this.recommendations.push({
                    title: this.petition.title,
                    thumbnail: this.petition.image,
                    status: this.petition.status === 'closed' ? 'Signing Closed' : 'Signing Open',
                    facts: this.petition.closes_at ? [`Ends ${new DatePipe('e-US').transform(this.petition.closes_at, 'date')}`] : [],
                    url: `/campaigns/${this.petition.slug || this.petition.id}`
                })
            } else {
                this.recommendations.push({ title: 'All Petitions Signed, Nice Job!' });
            }

            if (this.poll) {
                this.recommendations.push({
                    title: this.poll.title,
                    thumbnail: this.poll.image,
                    status: this.poll.status === 'closed' ? 'Voting Closed' : 'Voting Open',
                    facts: this.poll.closes_at ? [`Ends ${new DatePipe('e-US').transform(this.poll.closes_at, 'date')}`] : [],
                    url: `/polls/${this.poll.slug || this.poll.id}`

                })
            } else {
                this.recommendations.push({ title: 'ALl Polls Voted On, Nice Job!' });
            }

            this.state = 'ready';
        }
    }

    /**
     * Temporary hack while I wait for the API to be deployed to staging
     */
    asArray(value: string | string[]) {
        if (typeof value === 'string')
            return [value];
        else
            return value;
    }
}